import { startCase } from 'lodash'
import { ScopeTreeBranchInterface, ScopeTreeInterface } from '@/services/Scopes/Interfaces'
import { Treeview } from '@/views/interfaces/vuetify/treeview.interface'

export class ScopeTree implements ScopeTreeInterface {
  public id: string;

  constructor(
    public name: string,
    public children: {[branchName: string]: ScopeTreeBranchInterface} = {},
    public disabled: boolean = false,
  ) {
    this.id = String(Math.floor(Math.random() * 5000) + 5000)
  }

  public hasChild(child: string): boolean {
    return this.children[child] !== undefined
  }

  public addChild(child: ScopeTreeBranchInterface): void {
    this.children[child.name] = child
  }

  public getChild(child: string): ScopeTreeBranchInterface {
    return this.children[child]
  }

  public toTreeView(): Treeview {
    return {
      id: this.id,
      name: startCase(this.name.toLowerCase()),
      disabled: this.disabled,
      children: Object.values(this.children).map((treeBranch: ScopeTreeBranchInterface) => {
        return treeBranch.toTreeView()
      }),
    }
  }

}
